import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, FormControl, FormLabel, Input, useToast } from '@chakra-ui/react';
import { secureFetch } from '../data/secureFetch';

const UpdateEmail = () => {
  const { organizationId } = useSelector((state) => state.user);
  const [email, setEmail] = useState('');
  const toast = useToast();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // fix endpoint first
      const response = await secureFetch(`/api/organizations/${organizationId}/update-email`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        data: { email },
      });

      if (response.ok) {
        toast({
          title: "Success",
          description: "Email updated and verified successfully",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      } else {
        throw new Error('Failed to update email');
      }
    } catch (error) {
      console.error('Error updating email:', error);
      toast({
        title: "Error",
        description: "Failed to update email",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  return (
    <Box p={5} maxW="600px" mx="auto">
      <form onSubmit={handleSubmit}>
        <FormControl mb={4}>
          <FormLabel>Email</FormLabel>
          <Input
            name="email"
            value={email}
            onChange={handleChange}
          />
        </FormControl>
        <Button colorScheme="orange" type="submit">
          Update Email
        </Button>
      </form>
    </Box>
  );
};

export default UpdateEmail;
